<template>
  <form-wrapper>
    <b-form @submit="onSubmit">
      <h2 class="text-center">
        Edit Question
      </h2>

      <edit-question
        v-model="question"
        :knowledgecheck="value"
        @saved="onSubmit"
        @canceled="onCancel"
      ></edit-question>

    </b-form>

  </form-wrapper>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import editQuestion from '../questions/edit'
import formWrapper from '@/components/common/form/form-wrapper'

export default {
  components:{
    editQuestion,
    formWrapper
  },
  props:{
    value: {type:Object, default:null},
    question: {type:Object, required:true}
  },
  data(){
    return {
      innerModel: {},
      saving: false,
      fetching: false
    }
  },
  computed: {
    ...mapState('tenants', {
      organization: 'current'
    }),
    ...mapState('components', {
      component: 'current'
    }),
    disabled(){
      return this.fetching || this.saving
    }
  },
  watch: {
    value(val){
      if(val != this.innerModel){
        this.innerModel = val
      }
    }
  },
  methods:{
    ...mapActions('components', {
      refresh: 'show'
    }),
    onSubmit(q) {
      this.$emit('edited',q)
      this.resetForm()
    },
    onCancel() {
      this.$emit('cancel')
      this.resetForm()
    },
    resetForm(){

    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/pages/admin/knowledge-checks/components/edit-question.vue